import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { api, type WorkOrder } from '../../lib/api'
import { Loading, Alert } from '../../components/ui'
import WorkOrderDoc from './WorkOrderDoc'

/** 一次列印多張發包單；每張在列印時自動另起一頁（見 styles.css 的 .print-doc + .print-doc） */
export default function WorkOrdersBatchPrint() {
  const [params] = useSearchParams()
  const ids = (params.get('ids') ?? '').split(',').map((s) => s.trim()).filter(Boolean)

  const [orders, setOrders] = useState<WorkOrder[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    if (ids.length === 0) {
      setError('沒有選取任何發包單')
      return
    }
    Promise.all(ids.map((id) => api.get<WorkOrder>(`/work-orders/${id}`)))
      .then((list) => list.sort((a, b) => a.code.localeCompare(b.code)))
      .then(setOrders)
      .catch((e) => setError(e.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.get('ids')])

  return (
    <>
      <div className="page-head no-print">
        <h2>批次列印發包單（{ids.length} 張）</h2>
        <div className="spacer" />
        <div className="btn-row">
          <button className="primary" onClick={() => window.print()} disabled={!orders}>
            列印全部 / 存成 PDF
          </button>
          <Link to="/work-orders"><button>返回清單</button></Link>
        </div>
      </div>

      <Alert kind="error">{error}</Alert>

      {!error && !orders && <Loading />}

      {orders?.map((w) => <WorkOrderDoc key={w.id} w={w} />)}
    </>
  )
}
